/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.academics.course-catalogs'},
});

const CourseCatalogsItem = () => (
  <RouteLinkItem
    route="midas/settings/academics/course-catalogs"
    title={messages.title}
  />
);

export default CourseCatalogsItem;
